import { logoLinksSearchStyles as logoSection } from "@insite/content-library/Widgets/Header/LogoLinksSearch";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

logoSection.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        max-width: 1220px;
        padding: 0 20px;
        margin: auto;
    `,
};

logoSection.logoWrapper = {
    css: css`
        text-align: left;
        padding: 20px 0;

        img {
            height: 78px;
        }

        ${mediaQueriesBP.maxMD} {
            img {
                height: 42px;
                width: auto;
                margin: 0;
            }
        }
    `,
};

logoSection.searchMenuWrapper = {
    css: css`
        text-align: right;
        padding: 20px 0;

        ${mediaQueriesBP.maxMD} {
            display: none;
        }

        ${mediaQueriesBP.minLG} {
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
        }
    `,
};
